export const NoticeType = [
  "Rent",
  "Maintenance",
  "Vacate",
  "Warning",
  "Others",
];
export default NoticeType;
